"use client";

import { useEffect, useState } from "react";
import { axiosAdmin } from "@/lib/axios";
import { useAuthStore } from "@/store/AuthStore";

// On first load there is no access token in memory (we no longer persist it).
// Ask the server to validate the httpOnly refreshToken cookie and, if valid,
// restore the session via POST /user/auth/refresh-token before rendering the app.
export default function SessionRestore({
  children,
}: {
  children: React.ReactNode;
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = useAuthStore.getState().accessToken;
    if (token) {
      setReady(true);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const { data } = await axiosAdmin.post<{
          accessToken: string;
          user?: any;
        }>("/user/auth/refresh-token");
        if (!cancelled && data.accessToken) {
          useAuthStore
            .getState()
            .setUserData(
              (data.user
                ? { ...data, accessToken: data.accessToken }
                : useAuthStore.getState().user) as any,
              data.accessToken
            );
        }
      } catch (err) {
        // No valid cookie → stay logged out, nothing to do.
        useAuthStore.getState().clearAuth();
      } finally {
        if (!cancelled) setReady(true);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) return null;

  return <>{children}</>;
}